import { Skeleton } from '@/core/components/ui/skeleton';

interface GridLoadingStateProps {
  rowCount?: number;
  columnCount?: number;
}

/**
 * Loading state component for the kiosk sessions grid
 * Shows skeleton rows while data is being fetched with high-contrast animation
 */
export const GridLoadingState = ({ 
  rowCount = 5, 
  columnCount = 8 
}: GridLoadingStateProps) => {
  return (
    <div className="w-full">
      <div className="border rounded-md">
        {/* Header skeleton */}
        <div className="flex border-b bg-gray-100 p-4">
          {Array.from({ length: columnCount }).map((_, index) => (
            <div key={`header-${index}`} className="flex-1 px-2">
              <Skeleton className="h-4 w-full bg-gray-300" />
            </div>
          ))}
        </div>
        
        {/* Row skeletons */}
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <div key={`row-${rowIndex}`} className="flex border-b p-4 bg-white">
            {Array.from({ length: columnCount }).map((_, colIndex) => (
              <div key={`cell-${rowIndex}-${colIndex}`} className="flex-1 px-2">
                <Skeleton className="h-4 w-full bg-gray-200" />
              </div>
            ))}
          </div>
        ))}
      </div>
      
      <div className="flex items-center justify-center mt-4">
        <div className="flex items-center space-x-2 text-sm text-gray-700">
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-gray-300 border-t-blue-600"></div>
          <span className="font-medium">Loading session data...</span>
        </div>
      </div>
    </div>
  );
};